// extracted by mini-css-extract-plugin
export var cardIcon = "_a1-5";
export var cardIconUnframed = "_a1-9";
export var checkboxCard = "_a1-0";
export var checkboxCardSelected = "_a1-4";
export var disabled = "_a1-2";
export var interactive = "_a1-1";
export var outerBorder = "_a1-3";
export var spacerMedium = "_a1-8";
export var spacerSmall = "_a1-7";
export var spacerXsmall = "_a1-6";